function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import cn from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';
import { FormattedMessage } from 'react-intl';
import Button from 'components/Form/Button';
import Download from 'svg/download.svg';
import ChevronRight from 'svg/chevron-right.svg';
import PatientResults from 'modules/PatientResults';
import ReportDropdown from './ReportDropdown';
import styles from './ReportButton.pcss';
const ReportButton = ({ storeSelectedReportTypes, goToReportsView, isInProgress = false })=>{
    useStyles(styles);
    const [isOpen, setIsOpen] = useState(false);
    const onClick = ()=>setIsOpen(true);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.topBar__generateReport,
        children: [
            /*#__PURE__*/ _jsxs(Button, {
                styleModifier: "transparent",
                className: cn(styles.topBar__button, styles['topBar__button--right'], styles['topBar__button--active']),
                isDisabled: isInProgress,
                onClick: onClick,
                children: [
                    /*#__PURE__*/ _jsx(Download, {}),
                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, PatientResults.messages.buttons.generateReport)),
                    /*#__PURE__*/ _jsx(ChevronRight, {
                        className: styles.chevronIcon
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ReportDropdown, {
                storeSelectedReportTypes: storeSelectedReportTypes,
                goToReportsView: goToReportsView,
                isInProgress: isInProgress,
                isOpen: isOpen,
                setIsOpen: setIsOpen
            })
        ]
    });
};
export default ReportButton;
